import { render, staticRenderFns } from "./CTAView.vue?vue&type=template&id=7fea1134"
import script from "./CTAView.vue?vue&type=script&lang=js"
export * from "./CTAView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports